document.addEventListener("DOMContentLoaded", function () {
  jQuery(".resources__download-button--video").each(function (i, obj) {
    jQuery(this).on("click", function (e) {
      e.preventDefault();
      var videoID = jQuery(this).data("video-id");
      var videoSelector = "#" + videoID;

      var videoModal = jQuery(videoSelector);
      jQuery(videoModal).fadeIn();
      jQuery("body").addClass("video-active");

      var iframe = jQuery(videoModal).find("iframe");
      if (iframe) {
        var src = jQuery(iframe).attr("src");
        var autoSrc = src + (src.includes("?") ? "&" : "?") + "autoplay=1";
        jQuery(iframe).attr("src", autoSrc);
        if (jQuery(iframe).attr("original-src", src)) {
          jQuery(iframe).attr("original-src", src);
        }
      }
    });
  });

  jQuery(".download_button_video__close").on("click", function (e) {
    e.preventDefault();
    jQuery(".featured-download-video__wrapper").fadeOut();
    jQuery("body").removeClass("video-active");
    var iframe = jQuery(this).parent().find("iframe");
    if (iframe) {
      if (jQuery(iframe).attr("original-src")) {
        jQuery(iframe).attr("src", jQuery(iframe).attr("original-src"));
      } else {
        jQuery(iframe).attr("src", jQuery(iframe).attr("src"));
      }
    }
  });
});
